import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@@common';

import { UserInterfaceClient } from '../../../api/api';

export type EmbedAppView = { Id: string; Title?: string; RoutePath?: string; RequiresAuthentication?: boolean };
export const getEmbedViewName = (view: EmbedAppView | undefined, id: string) => view?.Title || view?.RoutePath || id;

export function useEmbedApp(appDefinitionId: string, changeSetId?: string) {
	const apps = useApiClient(UserInterfaceClient);
	return useQuery({
		queryKey: ['embedApp', appDefinitionId, changeSetId],
		enabled: !!appDefinitionId,
		queryFn: async ({ signal }) => {
			const app = await apps.getByDefinitionId(appDefinitionId, changeSetId, signal);
			return { name: app.name, views: (JSON.parse(app.definition) as { Views?: EmbedAppView[] }).Views ?? [] };
		},
	});
}
